<div #qrCodeContainer></div>
